
import img1 from '../../../assets/images/temp/RL-Image.png'
import rl1 from '../../../assets/images/temp/RL1.png'
import rl2 from '../../../assets/images/temp/RL2.png'
import rl3 from '../../../assets/images/temp/RL3.png'
import rl4 from '../../../assets/images/temp/RL4.png'
import rl5 from '../../../assets/images/temp/RL5.png'
import rl6 from '../../../assets/images/temp/RL6.png'
import rl7 from '../../../assets/images/temp/RL7.png'

export const RiskData = [
    {
        risk: 'VERY HIGH',
        id: 'add21442',
        title: 'Supply chain disruptions',
        details: 'Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures.',
        image: img1,
        data: [
            {
                title: 'relevance',
                value: '56%',
                change: '8%',
                isRiskUp: false
            },
            {
                title: 'indicators',
                value: '6%',
                change: '5%',
                isRiskUp: true
            },
            {
                title: 'indicators',
                value: '14%',
                change: '2',
                isRiskUp: true
            },
        ]
    },
    {
        risk: 'VERY HIGH',
        title: 'Cost of living crisis',
        details: 'Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures.',
        image: rl1,
        id: 'a4442',
        data: [
            {
                title: 'relevance',
                value: '56%',
                change: '8%',
                isRiskUp: false
            },
            {
                title: 'indicators',
                value: '6%',
                change: '5%',
                isRiskUp: true
            },
            {
                title: 'indicators',
                value: '14%',
                change: '2',
                isRiskUp: true
            },
        ]
    },
    {
        risk: 'VERY HIGH',
        title: 'Natural disasters and extreme wea... ',
        details: 'Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures.',
        image: rl2,
        id: '989q2',
        data: [
            {
                title: 'relevance',
                value: '56%',
                change: '8%',
                isRiskUp: false
            },
            {
                title: 'indicators',
                value: '6%',
                change: '5%',
                isRiskUp: true
            },
            {
                title: 'indicators',
                value: '14%',
                change: '2',
                isRiskUp: true
            },
        ]
    },
    {
        risk: 'VERY HIGH',
        title: 'Failure to mitigate climate change',
        details: 'Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures.',
        image: rl3,
        id: 'adji902',
        data: [
            {
                title: 'relevance',
                value: '56%',
                change: '8%',
                isRiskUp: false
            },
            {
                title: 'indicators',
                value: '6%',
                change: '5%',
                isRiskUp: true
            },
            {
                title: 'indicators',
                value: '14%',
                change: '2',
                isRiskUp: true
            },
        ]
    },
    {
        risk: 'VERY HIGH',
        title: 'Erosion of social cohesion and pola...',
        details: 'Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures.',
        image: rl4,
        id: '980gu',
        data: [
            {
                title: 'relevance',
                value: '56%',
                change: '8%',
                isRiskUp: false
            },
            {
                title: 'indicators',
                value: '6%',
                change: '5%',
                isRiskUp: true
            },
            {
                title: 'indicators',
                value: '14%',
                change: '2',
                isRiskUp: true
            },
        ]
    },
    {
        id: '7878bugu',
        risk: 'VERY HIGH',
        title: 'Widespread cyber crime and cyber i...',
        details: 'Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures.',
        image: rl5,
        data: [
            {
                title: 'relevance',
                value: '56%',
                change: '8%',
                isRiskUp: false
            },
            {
                title: 'indicators',
                value: '6%',
                change: '5%',
                isRiskUp: true
            },
            {
                title: 'indicators',
                value: '14%',
                change: '2',
                isRiskUp: true
            },
        ]
    },
    {
        id: '87hjhi',
        risk: 'VERY HIGH',
        title: 'Large-scale involuntary migration',
        details: 'Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures.',
        image: rl6,
        data: [
            {
                title: 'relevance',
                value: '56%',
                change: '8%',
                isRiskUp: false
            },
            {
                title: 'indicators',
                value: '6%',
                change: '5%',
                isRiskUp: true
            },
            {
                title: 'indicators',
                value: '14%',
                change: '2',
                isRiskUp: true
            },
        ]
    },
    {
        id: '989jkml8',
        risk: 'VERY HIGH',
        title: 'Geo-economic confrontation',
        details: 'Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures.',
        image: rl7,
        data: [
            {
                title: 'relevance',
                value: '56%',
                change: '8%',
                isRiskUp: false
            },
            {
                title: 'indicators',
                value: '6%',
                change: '5%',
                isRiskUp: true
            },
            {
                title: 'indicators',
                value: '14%',
                change: '2',
                isRiskUp: true
            },
        ]
    },
]